import { generateRandomString } from '@utils'

export const useSessionFingerprint = () => {
  // SSR guard - return undefined during server-side rendering
  if (typeof window === 'undefined' || !window.sessionStorage || !window.localStorage) {
    return
  }

  let userIdentity = window.localStorage.getItem('identity')
  let sessionIdentity = window.sessionStorage.getItem('fingerprint')

  if (!userIdentity) {
    userIdentity = generateRandomString(25)
    window.localStorage.setItem('identity', userIdentity)
  }

  if (!sessionIdentity) {
    sessionIdentity = generateRandomString(25)
    window.sessionStorage.setItem('fingerprint', sessionIdentity)
  }

  return `${userIdentity}:${sessionIdentity}`
}
